import { countries } from "countries-list";

/**
 * Converts a country name to ISO2 country code
 * @param countryName - Country name (e.g., "Germany", "Deutschland", "United States")
 * @returns ISO2 country code (e.g., "DE", "US") or null if not found
 */
export const getCountryCode = (countryName: string | undefined | null): string | null => {
    if (!countryName) return null;

    const normalizedName = countryName.trim().toLowerCase();

    // First, try direct lookup by country name
    const countryEntry = Object.entries(countries).find(([, country]) => {
        const name = country.name?.toLowerCase();
        return name === normalizedName;
    });

    if (countryEntry) {
        return countryEntry[0].toLowerCase();
    }

    // Try matching by common variations
    const countryMap: Record<string, string> = {
        germany: "de",
        deutschland: "de",
        "united states": "us",
        usa: "us",
        "united kingdom": "gb",
        uk: "gb",
        "great britain": "gb",
        spain: "es",
        spanien: "es",
        france: "fr",
        frankreich: "fr",
        italy: "it",
        italien: "it",
        netherlands: "nl",
        niederlande: "nl",
        belgium: "be",
        belgien: "be",
        switzerland: "ch",
        schweiz: "ch",
        austria: "at",
        österreich: "at",
        turkey: "tr",
        türkei: "tr",
        poland: "pl",
        polen: "pl",
        portugal: "pt",
        greece: "gr",
        griechenland: "gr",
        sweden: "se",
        schweden: "se",
        norway: "no",
        norwegen: "no",
        denmark: "dk",
        dänemark: "dk",
        finland: "fi",
        finnland: "fi",
    };

    const mappedCode = countryMap[normalizedName];
    if (mappedCode) {
        return mappedCode;
    }

    // Try partial matching
    for (const [code, country] of Object.entries(countries)) {
        const name = country.name?.toLowerCase();
        if ((name && name.includes(normalizedName)) || normalizedName.includes(name)) {
            return code.toLowerCase();
        }
    }

    return null;
};
